<div class="authentication-init">
  <div class="content">
    <div class="header" @fadeIn>
      <img class="logo" src="assets/images/logo-big.png" />
      <div class="title" @slideIn>Aurora</div>
    </div>
    <div class="subtitle" @fadeIn>Hyperspectral Data Analysis</div>
  </div>
</div>
